export const USERS = [
  {
    username: 'pbp_admin',
    password: 'pbp_admin123', // tylko demo, nie do produkcji
    role: 'admin',
    firstName: 'Anna',
    lastName: 'Kowalska',
    position: 'Psycholog',
    phone: '+48 600 000 001',
    email: 'anna.kowalska@example.com',
  },
  {
    username: 'joanna.palka@inetria.pl',
    password: 'joanna.palka@inetria.pljoanna.palka@inetria.pljoanna.palka@inetria.pl', // tylko demo, nie do produkcji
    role: 'admin',
    firstName: 'Joanna',
    lastName: 'Pałka',
    position: 'Psycholog',
    phone: '+48 609 609 609',
    email: 'joanna.palka@inetria.pl',
  },
  {
    username: 'pbp_user',
    password: 'pbp_user123',
    role: 'user',
    firstName: 'Jan',
    lastName: 'Nowak',
    position: 'Doradca zawodowy',
    phone: '+48 600 000 002',
    email: 'jan.nowak@example.com',
  },
];

